// import React, { Component } from "react";
import Button from "../button/Button";
import "./errorPage.scss";

function ErrorPage(props) {
  return (
    <>
      <div className="errorpage-404">
        <h1 className="mv-30 headline--secondary">{props.title}</h1>
        <p className="headline headline--quaternary mv-30">
          {props.description}
        </p>
        <div className="flex-center pv-50">
          {props.absoluteLink === "true" ? (
            <a className="btn btn--primary text-uppercase" href={props.path}>
              <span>{props.buttonTitle}</span>
            </a>
          ) : (
            <Button
              type="btn--primary"
              path={props.path}
              title={props.buttonTitle}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default ErrorPage;
